import './App.css'
import Background from './components/Background';
import ThemeContext from './context/theme-context';
import Changetheme from './components/Changetheme';
import TodoParent from './components/TodoParent';
function App() {
  return (
    <>
     <ThemeContext>
         <Background />
         <div className='box'>
              <header className='header'>
                <h1>TODO</h1>
                <Changetheme />
              </header>
              <TodoParent />
         </div>
      </ThemeContext>
    </>  
  );
}

export default App;
